/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type InfoStringListItem_item$ref: FragmentReference;
export type InfoStringListItem_item = {|
  +id: string,
  +title: ?string,
  +order: number,
  +infostring: ?boolean,
  +infostring_hot: ?boolean,
  +$refType: InfoStringListItem_item$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "InfoStringListItem_item",
  "type": "InfoString",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "order",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "infostring",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "infostring_hot",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'b178714d452a262dc5cb4eb6a1fc3854';
module.exports = node;



// WEBPACK FOOTER //
// src/components/info-strings/__generated__/InfoStringListItem_item.graphql.js